<template>


    <app-layout :title="__('Campaigns')">


        <div class="h-full">


            <div class="max-w-9xl mx-auto sm:px-6 lg:px-8 h-full">


                <div
                    class="grid grid-cols-2 h-full"
                    style="grid-template-rows: max-content minmax(200px, max-content);">


                    <div class="my-4 row-start-1">


                        <h1 class="text-2xl font-nexa text-dark-blue h-[30px]">

                            Campaigns

                        </h1>


                    </div>


                    <a class="p-2 my-3 bg-dark-blue row-start-1 items-center
                    justify-self-end self-center flex shadow-sm cursor-pointer"
                        href="https://us1.admin.mailchimp.com/campaigns/#/create-campaign"
                        target="_blank">



                        <h1 class="text-sm ml-1 font-nexa text-white">

                            Create Campaign

                        </h1>


                        <font-awesome-icon
                            class="mr-1 ml-2 text-white"
                            style="width: 16px; height: 16px;"
                            size="sm"
                            :icon="['fas', 'external-link']" />


                    </a>


                    <NordenTable
                        :headers="campaign_rule_headers"
                        :rows="campaign_rules_rows"
                        row_classes="hover:underline cursor-pointer hover:text-blue"
                        @click_on_row="handle_click_on_row" />


                </div>


            </div>


        </div>


    </app-layout>


</template>


<script>
import { defineComponent } from 'vue'
import AppLayout from '../Layouts/AppLayout.vue'
import NordenTable from "@/Components/NordenTable";

export default defineComponent({

    components: {
        NordenTable,
        AppLayout,
    },

    props: {
        campaign_rule_headers: {
            type: Array,
            default: () => {
                return [
                    {
                        name: 'Status',
                        text_key: 'status_text',
                        type: 'status',
                        value_key: 'status',
                        column_width: '75px',
                        class: 'text-center text-white hover:underline',
                        style: 'padding: 0;',
                    },
                    {
                        name: 'Campaign Name',
                        text_key: 'name',
                        value_key: 'name',
                        column_width: 4,
                        class: 'hover:underline truncate',
                    },
                    {
                        name: 'Frequency',
                        text_key: 'frequency_text',
                        value_key: 'frequency',
                        column_width: '160px',
                        class: 'hover:underline',
                    },
                    {
                        name: 'Last Sent',
                        text_key: 'last_sent',
                        value_key: 'last_sent',
                        column_width: '170px',
                        class: 'hover:underline',
                    },
                    {
                        name: 'Subscribers',
                        text_key: 'subscribers',
                        value_key: 'subscribers',
                        column_width: '110px',
                        class: 'hover:underline',
                    }
                ]
            }
        },
        campaign_rules: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: 'Simple',
                        frequency: 'instant',
                        status: 'active',
                        last_sent: '24/01/22 - 12:32',
                        subscribers: 1002
                    },
                    {
                        id: 2,
                        name: 'Extended',
                        frequency: 'everyday',
                        status: 'active',
                        last_sent: '24/01/22 - 14:12',
                        subscribers: 10045
                    },
                    {
                        id: 3,
                        name: 'Compact',
                        frequency: 'once_a_week',
                        status: 'active',
                        last_sent: '25/01/22 - 08:23',
                        subscribers: 452
                    },
                    {
                        id: 4,
                        name: 'Welcome new subscribers',
                        frequency: 'once',
                        status: 'active',
                        last_sent: '25/01/22 - 09:35',
                        subscribers: 1533
                    },
                    {
                        id: 5,
                        name: 'Remind to update preferences',
                        frequency: 'once_after_14_days',
                        status: 'active',
                        last_sent: '25/01/22 - 09:55',
                        subscribers: 757
                    },
                ];
            }
        },
    },


    computed: {

        campaign_rules_rows() {

            return _.map(this.campaign_rules, (campaign_rules) => {

                campaign_rules.status_text = this.status_as_text(campaign_rules.status);

                campaign_rules.frequency_text = this.frequency_as_text(campaign_rules.frequency);


                return campaign_rules;

            });

        }

    },


    methods: {

        frequency_as_text(frequency) {

            switch(frequency) {

                case 'instant':
                    return 'Instant';
                case 'daily':
                    return 'Daily';
                case 'weekly':
                    return 'Weekly';
                case 'once':
                    return 'Once';
                case 'once_after_14_days':
                    return 'Once after 14 days';
                default:
                    return 'No Frequency Found';

            }

        },


        status_as_text(status) {

            if ( status === 'active' ) {

                return this.__('Active');

            }
            if ( status === 'paused' ) {

                return this.__('Paused');

            }

            return this.__('No status');

        },

        handle_click_on_row(row) {

            this.$inertia.visit( this.route('campaign_rule', {campaign_rule: row.id}) );

        },

    }

})
</script>


